import { render, staticRenderFns } from "./cognitivebehavioral.vue?vue&type=template&id=7420fe8a&scoped=true&"
import script from "./cognitivebehavioral.vue?vue&type=script&lang=js&"
export * from "./cognitivebehavioral.vue?vue&type=script&lang=js&"
import style0 from "./cognitivebehavioral.vue?vue&type=style&index=0&id=7420fe8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7420fe8a",
  null
  
)

export default component.exports